import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button
} from "@mui/material"


const ResetPackage = ({ rowData, mainProps, setErrorMessage }) => {



  return (
    <Box>
      <Button
        color="primary"
        size="small"
        onClick={async () => {
            const { onResetPackage } = mainProps
            const message = rowData.packageSerialNumber?`serial:${rowData.packageSerialNumber}`:''
            if(window.confirm("آیا سریال پکیج ریست شود" + message)){
                await onResetPackage(rowData.id)
            }
           
        }}
      >
        ریست
      </Button>
    </Box>
  )
}

export default ResetPackage
